'use client';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import React, { useRef, useState } from 'react';
import { SITE } from '@/app/constants';
import { useDeferredMediaRender } from '../useDeferredMediaRender';
import { URL_CONFIG, WHY_VIDU_CONFIG } from './constants';

const WHY_VIDU_IMAGE_CLASS = 'aspect-[1.58/1] h-[200px] w-[316px] object-cover md:h-[100px] md:w-[158px]';

const WhyVidu = () => {
  const t = useTranslations('home3.whyVidu');
  const whyViduConfig = WHY_VIDU_CONFIG(t);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { ref: mediaGateRef, shouldRenderMedia } = useDeferredMediaRender<HTMLDivElement>('200px 0px');
  const [isHovering, setIsHovering] = useState(false);

  const handleWheel = (e: React.WheelEvent) => {
    if (isHovering && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop += e.deltaY;
    }
  };

  return (
    <div
      ref={mediaGateRef}
      className="mt-[134px] flex w-screen flex-col items-center overflow-hidden"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onWheel={handleWheel}
    >
      <h2 className="text-center font-medium text-[48px] md:text-[32px]">{t('title')}</h2>
      <div className="my-4 hidden h-[2px] w-[50px] bg-system-white opacity-25 md:block" />
      <div className="font-normal text-[14px] text-base text-white opacity-65 md:mx-[58px] md:text-center md:leading-6">
        {t('description')}
      </div>
      <div className="mt-20 flex items-center gap-[74px] md:flex-col lg:gap-[30px]">
        {whyViduConfig.map((item, index) => {
          const Icon = item.icon;
          return (
            <React.Fragment key={item.key}>
              <div
                key={item.key}
                className="flex w-[316px] flex-col justify-between md:items-center md:justify-center lg:w-[260px]"
              >
                <div className="flex w-[72px] items-center justify-center rounded-full border-[#006aff] border-[2px] border-solid bg-[#006aff]/60 px-6 py-[6px] shadow-[0px_0px_14px_0px_#3489FF_inset]">
                  <Icon className="size-6" />
                </div>
                <div className="flex flex-col md:flex-row md:items-center">
                  <h3 className="mt-2 text-nowrap font-semibold text-[28px] leading-normal md:mt-0 md:text-[24px] md:leading-[60px] lg:text-[28px]">
                    {item.title}
                    {SITE === 'china' && item.info}
                  </h3>
                  {SITE === 'global' && (
                    <div className="text-nowrap font-normal text-[#2882FF] text-[28px] leading-none md:text-[24px] md:leading-[60px] lg:text-[24px]">
                      {item.info}
                    </div>
                  )}
                </div>
                <div className="mt-3 text-[14px] text-white leading-[26px] opacity-60 md:mt-0 md:text-center">
                  {item.description}
                </div>
              </div>
              {/* 最后一个元素不显示分隔线 */}
              {index !== whyViduConfig.length - 1 && (
                <div
                  key={`${item.key}-divider`}
                  className="h-[131px] w-[2px] bg-white opacity-15 md:h-[2px] md:w-full"
                />
              )}
            </React.Fragment>
          );
        })}
        {/* 蒙层 */}
        <div className="absolute inset-x-0 bottom-0 z-10 h-[500px] bg-gradient-to-t from-transparent to-black md:pointer-events-none md:h-[230px]" />
      </div>
      <div
        className="relative flex w-[120%] justify-center md:w-[140%]"
        style={{ transform: 'perspective(800px) rotateX(30deg)' }}
      >
        <div
          ref={scrollContainerRef}
          className="scrollbar-hide max-h-[500px] overflow-y-auto md:max-h-[250px]"
          style={{ WebkitOverflowScrolling: 'touch' }}
        >
          <div className="flex flex-wrap justify-center gap-4 px-4">
            {URL_CONFIG.map((item) =>
              shouldRenderMedia ? (
                <Image
                  key={item.id}
                  src={item.url}
                  alt="why-vidu"
                  className={WHY_VIDU_IMAGE_CLASS}
                  width={316}
                  height={200}
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <div key={item.id} aria-hidden="true" className={`${WHY_VIDU_IMAGE_CLASS} bg-system-white06`} />
              ),
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyVidu;
